import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  margin-left: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  background: linear-gradient(", ", ", ");\n  border-radius: 5px;\n  box-shadow: ", ";\n  display: flex;\n  flex-shrink: 0;\n  height: ", ";\n  justify-content: center;\n  margin-right: ", ";\n  width: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  align-items: ", ";\n  display: flex;\n  flex-direction: row;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import { Card, PillIndicator } from '@scp/ui-shared/components';
import { Paragraph } from '@scp/ui-shared/components/typography';
import { Icon } from '@scp/ui-shared/theme/icons';
import { color, property } from '@scp/ui-shared/theme/variables';
import { rem, baselineToRem } from '@scp/ui-shared/theme/utils';
export var TEXT = {
  ACTIVE_APP: 'Active app'
};
var Row = styled.div(_templateObject(), function (_ref) {
  var centered = _ref.centered;
  return centered ? 'center' : 'flex-start';
});
var AppIconWrapper = styled.div(_templateObject2(), color.background, color.backgroundSecondary, property.boxShadow, rem('42px'), baselineToRem(3), rem('42px'));
var ActiveIndicator = styled(PillIndicator)(_templateObject3(), baselineToRem(2));
export var AppLinkCard = function AppLinkCard(_ref2) {
  var title = _ref2.title,
      subTitle = _ref2.subTitle,
      iconName = _ref2.iconName,
      url = _ref2.url,
      isActiveApp = _ref2.isActiveApp,
      onClick = _ref2.onClick,
      _ref2$titleElement = _ref2.titleElement,
      titleElement = _ref2$titleElement === void 0 ? 'h4' : _ref2$titleElement;
  return React.createElement(Card, {
    href: isActiveApp || !url ? undefined : url,
    onClick: isActiveApp || !url ? undefined : onClick,
    isExternalAction: !isActiveApp,
    innerHorizontalMargin: 16,
    innerVerticalMargin: 12
  }, React.createElement(Row, null, React.createElement(AppIconWrapper, null, React.createElement(Icon, {
    name: iconName,
    size: baselineToRem(6)
  })), React.createElement("div", null, React.createElement(Row, {
    centered: true
  }, React.createElement(Paragraph, {
    as: titleElement,
    bold: true,
    noMargin: true
  }, title), isActiveApp && React.createElement(ActiveIndicator, {
    type: "small",
    color: "light-green"
  }, TEXT.ACTIVE_APP)), React.createElement(Paragraph, {
    secondary: true,
    noMargin: true
  }, subTitle))));
};